import React from "react";

const TherapistContext = React.createContext();
TherapistContext.displayName = "TherapistContext";

export default TherapistContext;
